<div class="header">
  <div class="left">
    <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
  </div>

  <div class="right">
    <span class="user-name" *ngIf="identity || token && false">
      {{ identity?.nombres + ' ' + identity?.apellidoP + ' ' + identity?.apellidoM }}
    </span>
    <button mat-button [matMenuTriggerFor]="menu" *ngIf="identity || token && false">
      <mat-icon class="icon" matBadgeColor="warn">person</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="openPerfil()">
        <mat-icon class="icon" matBadgeColor="warn">person</mat-icon> Mi perfil
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon> Cerrar Sesi&oacute;n
      </button>
    </mat-menu>
    <button mat-icon-button matTooltip="Servicios" aria-label="Volver al inicio" (click)="back()">
      <mat-icon class="icon">home</mat-icon>
    </button>
  </div>
</div>


<div class="container" *ngIf="!buscando">

  <mat-card class="example-card">
    <mat-card-header>
      <div class="row" style="width: 100%;">
        <div mat-card-avatar class="example-header-image"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="title1b">Seguimiento de Expediente</div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subTitle">
          <p>Dirección de Obras Municipales</p>
        </div>
      </div>
    </mat-card-header>
    <mat-card-content>

      <div class="row">

        <div class="rol-div">
          <h4 class="card-title">Ingrese el RUT de la Persona o Empresa</h4>
          <mat-form-field class="mat-field-rol">
            <input matInput type="text" placeholder="RUT sin puntos y con guion" [formControl]="rut" >
          <!--   <button mat-button *ngIf="rut.value" matSuffix mat-icon-button aria-label="Clear"
              (click)="rut.setValue('')">
              <mat-icon>close</mat-icon>
            </button> -->
          </mat-form-field>
        </div>

        <div class="rol-div">
          <h4 class="card-title">Ingrese Número de Solicitud</h4>
          <mat-form-field class="mat-field-rol">
            <input matInput type="text" placeholder="Nº Solicitud" [formControl]="numSol">
            <button mat-button *ngIf="numSol.value" matSuffix mat-icon-button aria-label="Clear"
              (click)="numSol.setValue('')">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>


        <div class="btn-cont">
          <button color="primary" mat-raised-button (click)="get_expediente(numSol.value, rut.value)"
            [disabled]="!numSol.valid && !rut.valid">Búsqueda</button>
        </div>

      </div>

    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>
  </mat-card>
</div>

<div class="container" *ngIf="buscando">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12" align="right">
      <p>
        <button color="primary" mat-raised-button (click)="volver()">Volver a buscar</button>
      </p>
    </div>

  </div>
  <mat-card class="example-card">
    <mat-card-header>
      <div class="row" style="width: 100%;">
        <div class="get-data-cont">

          <div class="title1b" align="center">Número de Solicitud : {{
            expediente_info[0].fieldData['Tramite_Solicitudes::_TRA_ID'] }}</div>
        </div>

      </div>

    </mat-card-header>
    <mat-card-content>
      <br>
      <div class="row">
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
          <label class="parag">Dirección:</label>
        </div>
        <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <label class="parag">{{ expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Pro_Direccion'] ?
            expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Pro_Direccion'] : 'No hay información ingresada'
            }}</label>
        </div>
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
      </div>

      <div class="row">
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
          <label class="parag">Expediente:</label>
        </div>
        <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <label class="parag">{{ expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Expediente'] ?
            expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Expediente'] : 'No hay información ingresada' }}
          </label>
        </div>
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
      </div>


      <div class="row">
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
          <label class="parag">Propiedad:</label>
        </div>
        <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <label class="parag">{{ expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Pro_Rol_Imprimir'] ?
            expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Pro_Rol_Imprimir'] : 'No hay información ingresada'
            }} </label>
        </div>
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
      </div>

      <div class="row">
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
          <label class="parag">Fecha Ingreso:</label>
        </div>
        <div class="name_info col-lg-6 col-md-8 col-sm-6 col-xs-6">
          <label class="parag">{{ expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Fecha_Creacion'] ?
            expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Fecha_Creacion'] : 'No hay información ingresada' }}
          </label>
        </div>
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
      </div>

      <div class="row">
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
          <label class="parag">Estado:</label>
        </div>
        <div class="name_info col-lg-8 col-md-8 col-sm-8 col-xs-8">
          <label class="parag">{{ expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Estado_WEB'] ?
            expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Estado_WEB'] : 'No hay información ingresada'
            }} </label>
        </div>
        <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
      </div>

      <mat-accordion *ngIf="expa1==true">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="{{colorExpa1}}">
              Arquitecto Revisor
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row" *ngIf="expediente_info[0].fieldData['Administracion 5::Adm_Nombre_Completo']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Nombre:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['Administracion 3::Adm_Nom_Completo'] ?
                expediente_info[0].fieldData['Administracion 3::Adm_Nom_Completo'] : 'No hay información ingresada' }}
              </label>
            </div>
          </div>

          <div class="row" *ngIf="expediente_info[0].fieldData['Administracion 5::Adm_Fono']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fono:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['Administracion 3::Adm_Fono'] ?
                expediente_info[0].fieldData['Administracion 3::Adm_Fono'] : 'No hay información ingresada' }} </label>
            </div>
          </div>

          <div class="row" *ngIf="expediente_info[0].fieldData['Administracion 5::Adm_Mail']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Email:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['Administracion 3::Adm_Mail'] ?
                expediente_info[0].fieldData['Administracion 3::Adm_Mail'] : 'No hay información ingresada' }} </label>
            </div>
          </div>

          <div class="row" *ngIf="expediente_info[0].fieldData['TCo_Acta_Fecha_1_Max_Emitir']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha Máxima Acta o Aprobación:</label>
            </div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">{{ expediente_info[0].fieldData['TCo_Acta_Fecha_1_Max_Emitir'] ?
                expediente_info[0].fieldData['TCo_Acta_Fecha_1_Max_Emitir'] : 'No hay información ingresada' }} </label>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion *ngIf="expa2==true">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="{{colorExpa2}}">
              Acta de Observaciones
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row" *ngIf="expediente_info[0].fieldData['Tex_Acta_Fecha_Emision']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha Emisión Acta:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['Tex_Acta_Fecha_Emision'] ?
                expediente_info[0].fieldData['Tex_Acta_Fecha_Emision'] : 'No hay información ingresada' }} </label>
            </div>
          </div>

          <div class="row" *ngIf="expediente_info[0].fieldData['Tex_Acta_Fecha_Notificacion']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha de Notificación:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['Tex_Acta_Fecha_Notificacion'] ?
                expediente_info[0].fieldData['Tex_Acta_Fecha_Notificacion'] : 'No hay información ingresada' }} </label>
            </div>
          </div>


          <div class="row" *ngIf="expediente_info[0].fieldData['Tex_Acta_Fecha_Reingreso']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha de Reingreso:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['Tex_Acta_Fecha_Reingreso'] ?
                expediente_info[0].fieldData['Tex_Acta_Fecha_Reingreso'] : 'No hay información ingresada' }} </label>
            </div>
          </div>

        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion *ngIf="expa3==true">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="{{colorExpa3}}">
              Cálculo de Derecho
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div *ngIf="calculoD">

            <div class="row" *ngIf="expediente_info[0].fieldData['Tex_CD_Fecha_Giro']!=''">
              <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
              <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <label class="parag">Fecha de Pago:</label>
              </div>
              <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <label class="parag">{{ expediente_info[0].fieldData['Tex_CD_Fecha_Giro'] ?
                  expediente_info[0].fieldData['Tex_CD_Fecha_Giro'] : 'No hay información ingresada' }} </label>
              </div>
            </div>

            <div class="row" *ngIf="expediente_info[0].fieldData['Tex_CD_Fecha_Notificacion']!=''">
              <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
              <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <label class="parag">Fecha de Notificación:</label>
              </div>
              <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <label class="parag">{{ expediente_info[0].fieldData['Tex_CD_Fecha_Notificacion'] ?
                  expediente_info[0].fieldData['Tex_CD_Fecha_Notificacion'] : 'No hay información ingresada' }} </label>
              </div>
            </div>

            <div class="row" *ngIf="expediente_info[0].fieldData['Tex_CD_TOTAL_PAGAR_Estampillas']!='$0' ">
              <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
              <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <label class="parag">Total a Pagar:</label>
              </div>
              <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <label class="parag">{{ expediente_info[0].fieldData.Tex_CD_TOTAL_PAGAR_Estampillas ?
                  expediente_info[0].fieldData.Tex_CD_TOTAL_PAGAR_Estampillas : 'No hay información ingresada' }}
                </label>
              </div>
              <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            </div>

          </div>

        </mat-expansion-panel>
      </mat-accordion>


      <mat-accordion *ngIf="expa4==true">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="{{colorExpa4}}">
              Aprobación
            </mat-panel-title>
          </mat-expansion-panel-header>


          <div class="row" *ngIf="expediente_info[0].fieldData['Tex_Apr_Numero']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Numero de Aprobación:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['Tex_Apr_Numero'] ?
                expediente_info[0].fieldData['Tex_Apr_Numero'] : 'No hay información ingresada' }} </label>
            </div>
          </div>

          <div class="row" *ngIf="expediente_info[0].fieldData['Tex_Fecha_Aprobacion']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha de Aprobación:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['Tex_Fecha_Aprobacion'] ?
                expediente_info[0].fieldData['Tex_Fecha_Aprobacion'] : 'No hay información ingresada' }} </label>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>





    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>
  </mat-card>

</div>